import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import HomeSlider from "../ones/HomeSlider";
import WhyChooseUs from "./WhyChooseUs";
import Footer from "../ones/Footer";
import PageWithSidebar from "../components/PageWithSidebar";
import LoanCalculator from "./LoanCalculator";
import HomeServices from "./HomeServices";
import HomeNews from "./HomeNews";
import Sponsors from "./Sponsors";

export default function View(props) {
  /* Place states here */
  const [ready, setReady] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    //..

    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <>
        <HomeSlider />
        <PageWithSidebar>
          <WhyChooseUs />
          <LoanCalculator />
		  <HomeServices />
      <HomeNews />
      <Sponsors />
        </PageWithSidebar>
		
		  
        <Footer />
      </>
    );
  } else {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }
}
